import React from 'react';
import { C, CARD_W, CARD_H, nx, ny } from '../flowCanvas.constants';

const HEADER_H  = 40;
const LABEL_X   = 12;
const CONTROL_X = 96;
const CONTROL_W = CARD_W - CONTROL_X - 12;
const ROW_H     = CARD_H - HEADER_H;

function TogglePill({ x, y, active, onClick }) {
  const width = CONTROL_W;
  return (
    <g onClick={(e) => { e.stopPropagation(); onClick?.(); }} style={{ cursor: 'pointer' }}>
      <rect
        x={x} y={y} width={width} height={22} rx="11"
        fill={active ? 'rgba(74,222,128,0.12)' : 'rgba(255,255,255,0.05)'}
        stroke={active ? 'rgba(74,222,128,0.58)' : 'rgba(145,70,255,0.22)'}
        strokeWidth="1"
      />
      <circle cx={x + (active ? width - 11 : 11)} cy={y + 11} r="7"
        fill={active ? C.greenText : C.textMuted} />
      <text x={x + width / 2} y={y + 14} textAnchor="middle"
        fontSize="9" fontWeight="700" fill={active ? C.greenText : C.text}
        style={{ pointerEvents: 'none', userSelect: 'none' }}>
        {active ? 'Enabled' : 'Disabled'}
      </text>
    </g>
  );
}

export default function LiveTextSettingsNode({
  step,
  selected,
  onClick,
  centreY,
  overrideX,
  overrideY,
  liveCustomisationData,
  onToggleHeaders,
}) {
  const x = overrideX ?? nx(step);
  const y = overrideY ?? ny(step, centreY);
  const left = x - CARD_W / 2;
  const top  = y - CARD_H / 2;

  const addHeader     = liveCustomisationData?.setup?.templates?.settings?.[0]?.addHeader;
  const headersEnabled = addHeader !== false;

  const rowTop = top + HEADER_H;

  return (
    <g className="fc-node fc-node--live-text-settings" onClick={onClick} style={{ cursor: 'pointer' }}>
      <rect x={left + 2} y={top + 4} width={CARD_W} height={CARD_H} rx="10" fill="#000" fillOpacity="0.3" />
      <rect
        x={left} y={top} width={CARD_W} height={CARD_H} rx="10"
        fill={selected ? C.cardSel : C.card}
        stroke={selected ? C.sel : C.purple}
        strokeWidth={selected ? 2 : 1.5}
      />
      <line x1={left + 1} y1={top + HEADER_H} x2={left + CARD_W - 1} y2={top + HEADER_H}
        stroke={C.border} strokeWidth="1" />

      <text x={left + 14} y={top + 23} fontSize="11.5" fontWeight="700" fill={C.text}
        style={{ pointerEvents: 'none', userSelect: 'none' }}>
        {step.stepTitle || 'Text Settings'}
      </text>
      <text x={left + 14} y={top + 36} fontSize="8.5" fill={C.textMuted}
        style={{ pointerEvents: 'none', userSelect: 'none' }}>
        Toggle preset headers on or off
      </text>

      <text x={left + LABEL_X} y={rowTop + 22} fontSize="9" fontWeight="700" fill={C.textMuted}
        style={{ pointerEvents: 'none', userSelect: 'none' }}>
        Headers Enabled
      </text>
      <TogglePill
        x={left + CONTROL_X}
        y={rowTop + 7}
        active={headersEnabled}
        onClick={() => onToggleHeaders?.(!headersEnabled)}
      />
    </g>
  );
}
